import { Navigate, Route, Routes } from "react-router-dom";
import { SessionGate } from "./SessionGate";
import { Shell } from "./Shell";
import { LoginPage } from "../pages/LoginPage";
import { AdvertisersPage } from "../pages/AdvertisersPage";
import { AdvertiserDetailPage } from "../pages/AdvertiserDetailPage";
import { PlacementsPage } from "../pages/PlacementsPage";
import { PlacementDetailPage } from "../pages/PlacementDetailPage";
import { CampaignsPage } from "../pages/CampaignsPage";
import { CampaignDetailPage } from "../pages/CampaignDetailPage";
import { CreativesPage } from "../pages/CreativesPage";
import { CreativeDetailPage } from "../pages/CreativeDetailPage";
import { StatisticsPage } from "../pages/StatisticsPage";
import { IntegrationCredentialsPage } from "../pages/IntegrationCredentialsPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <SessionGate>
            <Shell>
              <Routes>
                <Route path="/" element={<Navigate to="/advertisers" replace />} />
                <Route path="/advertisers" element={<AdvertisersPage />} />
                <Route path="/advertisers/:id" element={<AdvertiserDetailPage />} />
                <Route path="/placements" element={<PlacementsPage />} />
                <Route path="/placements/:id" element={<PlacementDetailPage />} />
                <Route path="/campaigns" element={<CampaignsPage />} />
                <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
                <Route path="/creatives" element={<CreativesPage />} />
                <Route path="/creatives/:id" element={<CreativeDetailPage />} />
                <Route path="/statistics" element={<StatisticsPage />} />
                <Route path="/integration-credentials" element={<IntegrationCredentialsPage />} />
                <Route path="*" element={<p className="muted">Раздел ещё не реализован.</p>} />
              </Routes>
            </Shell>
          </SessionGate>
        }
      />
    </Routes>
  );
}
